.selected {
  border: 2px solid black;
}

.growShrink {
  /*Tell this element which properties to animate if something changes
  We are saying all properties will animate when changed seconds*/
  transition: all 0.4s;
}

.growShrink[data-state="on"] {
  transform: scale(1.05);
}

.correctAnswer {
  /* No special styling during slide, handled by parent */
}

.merging {
  animation: mergeToBar 0.44s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
}

.merging * {
  animation: hideText 0.25s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
}

@keyframes mergeToBar {
  0% {
    opacity: 1;
    transform: scale(1);
    height: auto;
  }
  60% {
    opacity: 0.5;
    transform: scale(0.7);
    height: auto;
  }
  100% {
    opacity: 0;
    transform: scale(0.1);
    height: 0;
    margin: 0;
    padding: 0;
  }
}

@keyframes hideText {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* .button {
  padding: 8px 8px;
  gap: 4px;
  border: none;
  border-radius: 4px;
  background: gray;
  color: white;
  font-weight: 600;
  font-size: 1.25rem;
  cursor: pointer;
  outline-offset: 4px;
}

.item:hover {
  cursor: pointer;
}

.item {
  width: 24px;
  max-width: 48px;
  min-width: 20px;
  min-height: 70px;
  height: 22.5vw;
  max-height: 22.5vw;
  font-size: 15px;
  background-color: grey;
  color: black;
  outline: none;
  text-align: center;
  font-family: "NYT-Franklin";
  font-weight: bold;
  border-radius: 6px;
  z-index: 0;
  position: absolute;
  transition: opacity 0.4s ease;
} */
